<template>
    <div class="login">
        <div class="slide-up form-wrapper" style="padding: 0;width:500px">
            <div style="padding:30px">
                <form @submit.prevent="submit()">
                    <input placeholder="Email" type="email" v-model="email" />
                    <input placeholder="Password" type="password" v-model="password" />
                    <input style="margin-bottom:20px" value="Log In" type="submit" placeholder="Submit" :class="submitted ? 'btn disable-button' : 'btn'">
                    <div v-if="loginError" style="color: red;">{{ loginErrorMessage }}</div>
                    <div style="margin-top:10px"><a @click.prevent="() => { showPasswordReset = true; }"  style="text-decoration:underline;">Forgot your Password?</a></div>
                </form>
            </div>
        </div>
        <div v-html="appHeightOverride"></div>
        <div v-if="showPasswordReset" class="error-msg-wrap">
            <div class="error-msg">
                <div style="font-size:24px">Enter the email for the account. If there is an account, you will receive an email with a link to reset your password.</div>
                <div style="margin-bottom: 15px"><input type="email" placeholder="Email" v-model="email" /></div>
                <div @click="() => { showPasswordReset = false }" class="btn-invert" style="margin-right:10px">Cancel</div>
                <div @click="submitPasswordReset()" class="btn" style="margin-left:10px">Submit</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import axios from 'axios';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'AdminLogIn',
    components: {

    },
    data() {
        return {
            email: '',
            password: '',
            submitted: false,
            loginError: false,
            loginErrorMessage: 'Email or password incorrect',
            appHeightOverride: '<style>#app-main{max-height: 100vh!important}</style>',
            showPasswordReset: false
        }
    },
    created() {
        this.$store.state.signedIn = false;
        this.$store.state.routeLoaded = true;
    },
    methods: {
        async submit() {
            this.submitted = true;
            this.loginError = false;

            await axios.post(`${this.$store.state.apiUrl}/api/adminlogin`, { email: this.email, password: this.password})
                .catch(e => {
                    // 429: locked out for a while after too many failed attempts (API loginLimit.ts)
                    this.loginErrorMessage = e?.response?.status == 429 && e.response.data ? e.response.data : 'Email or password incorrect';
                    this.loginError = true;
                    this.submitted = false;
                });
            
            if(this.loginError) {
                return;
            }

            // Edit App.vue as well
            await axios.get(`${this.$store.state.apiUrl}/api/session`)
                .then(resp => {
                    this.$store.state.user = resp.data;
                    localStorage.setItem('playbook_jwt', resp.data.jwt);
                    this.$store.state.signedIn = true;
                    this.$store.dispatch('setStoreData');
                    if(this.$route.query.redirect) {
                        this.$router.push(this.$route.query.redirect);
                    } else {
                        this.$router.push('/playbook/home');
                    }
                })
                .catch(e => {
                    this.loginError = true;
                    this.submitted = false;
                });
        },
        async submitPasswordReset() {
            if(!this.email) {
                return;
            }
            const data = {
                email: this.email.toLowerCase().trim()
            }
            await axios.post(`${this.$store.state.apiUrl}/api/resetpassword`, data)
                .then(resp => {
                    alert('You should receive an email shortly');
                    this.showPasswordReset = false;
                })
                .catch(e => {
                    alert('There was an error')
                });
        }
    }
})
</script>